import CommonImage from '@components/CommonImage';

import Chip from '@features/filter/Chip';
import TeamChip from '@features/filter/Common/TeamChip';
import UsersForTeamLead from '@features/filter/v1/core/UsersForTeamLead';

const BodyHeaderComponent = ({
	isFilterEnabled,
	title,
	addNewButtonText,
	addNewButtonCallback,
	totalElements,
	childElements,
	searchBar,
	whiteBg,
	showTeamLead,
	setShowFilter,
	sortType,
	setSortType,
	search,
	setSearch
}) => {
	return (
		<div className="top-header bg-white">
			{title && (
				<div className={`page-title-area ${whiteBg ? 'bg-white' : ''}`}>
					<h1 className="semibold-16">{title}</h1>
				</div>
			)}
			{childElements && childElements}
			<div className="filter-container-top">
				<div className="filters">
					{isFilterEnabled ? (
						<>
							<div className="filter-toggle" onClick={() => setShowFilter((prev) => !prev)}>
								<img src={`${process.env.PUBLIC_URL}/icons/filter24.svg`} alt="filter" />
								<span>Filter</span>
							</div>
							{totalElements && totalElements > 0 ? (
								<span className="items-count semibold-14 gray_dark_02 mt-1">
									{totalElements} {totalElements < 2 ? 'Item' : 'Items'}
								</span>
							) : (
								<></>
							)}
							<div className="chip-container ml-2">
								<div className="chips">
									<Chip />
								</div>
								<TeamChip />
							</div>
						</>
					) : (
						<></>
					)}
				</div>

				<div className="filter-actions d-flex align-items-center">
					{showTeamLead && (
						<div className="mr-2">
							<UsersForTeamLead />
						</div>
					)}
					{searchBar && searchBar}
					{isFilterEnabled && (
						<div className="sort-button list-pages-sort-btn mr-0 d-flex align-items-center">
							<div class="form-group size36 m-0 search-filter mr-2">
								<div class="with-icon right-icon">
									<input
										type="text"
										placeholder="Search"
										value={search}
										onChange={(e) => setSearch(e.target.value)}
									/>
									<span class="right-icon cursor-pointer">
										<CommonImage src={`/icons/search-dark.svg`} alt="" />
									</span>
								</div>
							</div>
							<div className="input-group size36 m-0">
								<div className="input-group-append">
									<button
										className="btn btn-outline-secondary dropdown-toggle sort"
										type="button"
										data-toggle="dropdown"
										aria-haspopup="true"
										aria-expanded="false"
									>
										<svg
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M3.99844 6H12.9984"
												stroke="#6A7181"
												strokeWidth="1.25"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M3.99844 12H10.9984"
												stroke="#6A7181"
												strokeWidth="1.25"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M3.99844 18H10.9984"
												stroke="#6A7181"
												strokeWidth="1.25"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M15 15L18 18L21 15"
												stroke="#6A7181"
												strokeWidth="1.25"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M18 6V18"
												stroke="#6A7181"
												strokeWidth="1.25"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</svg>
										<span>{sortType.label}</span>
									</button>
									<div className="dropdown-menu dropdown-menu-right">
										<a
											className="dropdown-item cursor-pointer"
											onClick={() => {
												setSortType({ label: 'Newest First', value: 'id,desc' });
											}}
										>
											Newest First
										</a>
										<a
											className="dropdown-item cursor-pointer"
											onClick={() => {
												setSortType({ label: 'Oldest First', value: 'id,asc' });
											}}
										>
											Oldest First
										</a>
									</div>
								</div>
							</div>
						</div>
					)}

					{addNewButtonText && (
						<div className="add-new-design">
							<button className="button secondary size32" onClick={addNewButtonCallback}>
								<span className="mr-2">{addNewButtonText}</span>
								<svg
									width="14"
									height="14"
									viewBox="0 0 14 14"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M13 8H8V13C8 13.55 7.55 14 7 14C6.45 14 6 13.55 6 13V8H1C0.45 8 0 7.55 0 7C0 6.45 0.45 6 1 6H6V1C6 0.45 6.45 0 7 0C7.55 0 8 0.45 8 1V6H13C13.55 6 14 6.45 14 7C14 7.55 13.55 8 13 8Z"
										fill="white"
									/>
								</svg>
							</button>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default BodyHeaderComponent;
